<template>
    <div data-app>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text
                    >Silmek istediğiniz kayıt kalıcı olarak silinecektir. Bu
                    kaydı silmek istediğinize emin misiniz?</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog = false">
                        Hayır
                    </v-btn>
                    <v-btn class="text-success" text @click="deleteMatch">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="col-md-12">   
            <KTCard v-bind:title="page_title">
                <template v-slot:body>
                    <form ref="form" id="form" novalidate="novalidate" lazy-validation class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                        <div class="m-portlet__body">

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Maç Türü:</label>
                                <div class="col-lg-9">
                                    <select class="form-control" v-model="match.type" :class="{view: !isEditing}" :disabled="!isEditing">
                                        <option v-for="match_type in match_types" :value="match_type" :key="match_type">{{ match_type }}</option>
                                    </select>
                                    <div v-if="errors.type" :errors="errors">
                                        <b-badge v-for="error in errors.type" class="mr-1" :key="error.type" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Maç İsmi:</label>
                                <div class="col-lg-9">
                                    <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="match.name">
                                    <div v-if="errors.name" :errors="errors">
                                        <b-badge v-for="error in errors.name" class="mr-1" :key="error.name" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Maç Tarihi:</label>
                                <div class="col-lg-9">
                                    <input type="date" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="match.match_date">
                                    <div v-if="errors.match_date" :errors="errors">
                                        <b-badge v-for="error in errors.match_date" class="mr-1" :key="error.match_date" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">Son Kayıt Tarihi:</label>
                                <div class="col-lg-9">
                                    <input type="date" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="match.last_registration_date">
                                    <div v-if="errors.last_registration_date" :errors="errors">
                                        <b-badge v-for="error in errors.last_registration_date" class="mr-1" :key="error.last_registration_date" variant="danger">{{ error }}</b-badge>
                                    </div>
                                </div>
                            </div>

                            <template v-if="timeStamps">
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Ekleyen:</label>
                                    <div class="col-lg-9">
                                        {{ match.user_created_name }}
                                    </div>
                                </div>
                                
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Ekleme Tarihi:</label>
                                    <div class="col-lg-9">
                                        <span>{{ match.created_at | formatDateTime }}</span>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Güncelleyen:</label>
                                    <div class="col-lg-9">
                                        {{ match.user_updated_name }}
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Güncelleme Tarihi:</label>
                                    <div class="col-lg-9">
                                        <span>{{ match.updated_at | formatDateTime }}</span>
                                    </div>
                                </div>

                        </template>
                          
                        </div>
                        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                            <div class="m-form__actions m-form__actions--solid">
                                <div class="row">
                                    <div class="col-lg-3"></div>
                                    <div class="col-lg-9">
                                        <!-- EKLEME BUTONLARI -->
                                        <template v-if="addButtons">
                                            <b-button
                                                v-if="hasPermission('matches.create')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="saveMatchAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Kaydet ve Geri Dön
                                            </b-button>
                                            
                                            <b-button
                                                v-if="hasPermission('matches.create')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="saveMatchAndAddNew()"
                                            >
                                            <i class="la la-save"></i>
                                                Kaydet ve Yeni Ekle
                                            </b-button>
                                        </template>

                                        <!-- GÜNCELLEME BUTONLARI -->
                                        <template v-if="editButtons">  
                                            <b-button
                                                v-if="hasPermission('matches.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="updateMatchAndGoBack()"
                                            >
                                            <i class="la la-save"></i>
                                            <i class="la la-rotate-left"></i>
                                                Güncelle ve Geri Dön
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('matches.update')"
                                                size="sm"
                                                variant="primary"
                                                :disabled="isDisabled"
                                                @click="updateMatch()"
                                            >
                                            <i class="la la-save"></i>
                                                Güncelle
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('matches.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            
                                            
                                        </template>

                                        <!-- GÖRÜNTÜLEME BUTONLARI -->
                                        <template v-if="viewButtons">
                                            <b-button
                                                v-if="hasPermission('matches.delete')"
                                                size="sm"
                                                variant="danger"
                                                :disabled="isDisabled"
                                                @click="dialog = true"
                                            >
                                            <i class="la la-trash"></i>
                                                Sil
                                            </b-button>

                                            <b-button
                                                v-if="hasPermission('matches.update')"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="changeFormToEditing()"
                                            >
                                            <i class="la la-edit"></i>
                                                Güncellemeyi Aktif Et
                                            </b-button>
 
                                        </template>   
                                        <template>
                                            <b-button 
                                                size="sm" 
                                                @click="$router.go(-1)">
                                                <i class="la la-undo"></i>
                                                İptal
                                            </b-button> 
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>
            </KTCard>
        </div>
        <div class="text-center">
            <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
                v-if="loading"
            ></b-spinner>
        </div>
    
    </div>



    
</template>

<script>

import KTCard from "@/view/content/Card.vue";
import { mapGetters} from 'vuex';
import { mapState} from 'vuex';
import { GET_MATCH_DATA } from "@/core/services/store/matches.module";
import { CREATE_MATCH } from "@/core/services/store/matches.module";
import { UPDATE_MATCH } from "@/core/services/store/matches.module";
import { DELETE_MATCH } from "@/core/services/store/matches.module";
import constants from '@/core/constants/index';

//import Echo from 'laravel-echo';

export default {
    name: "matches-form",
    
    data() {
        return {
            dialog: false,
            match:{
                achievements: [],
                user_created_name: "",
                user_updated_name: ""
            },
            formType: "",
            page_title: "",
            addButtons: false,
            editButtons: false,
            viewButtons: false,
            timeStamps: false,
            isEditing: true,
            matches: {},
            options: [
                { value: '1', text: 'Evet', selected: true },
                { value: '0', text: 'Hayır' },
            ],

            value: [],
            regions: constants.REGIONS,
            match_types: constants.MATCH_TYPES,
                        
        };
    },
   
    methods: {
        saveMatchAndGoBack() {
            const data = this.match;
            const goBack = true;
            this.$store.dispatch(CREATE_MATCH, {data, goBack})
        },

        saveMatchAndAddNew() {
            const data =  this.match;
            const goBack = false;
            this.$store.dispatch(CREATE_MATCH, {data, goBack})
        },

        updateMatchAndGoBack() {
            const data = this.match;
            const goBack = true;
            this.$store.dispatch(UPDATE_MATCH, { data, goBack })
        },

        updateMatch() {
            const data = this.match;
            const goBack = false;
            this.$store.dispatch(UPDATE_MATCH, { data, goBack })
        },

        deleteMatch() {
            var itemToDelete = this.match.id;
            this.$store.dispatch(DELETE_MATCH, { itemToDelete })
            .then(() => { 
                this.$router.go(-1);
                this.dialog = false;
            })
        },

        changeFormToAdding(){
            this.page_title = "Maç: Yeni Kayıt Formu"
            
            this.addButtons = true;
            this.editButtons = false;
            this.viewButtons = false;
            this.timeStamps = false;
            this.isEditing = true;
        },

        changeFormToEditing(){
            this.page_title = "Maç: Güncelleme Formu"
            this.addButtons = false;
            this.editButtons = true;
            this.viewButtons = false;
            this.timeStamps = true;
            this.isEditing = true;
        },

        changeFormToViewing(){
            this.page_title = "Maç: Detaylar"
            this.addButtons = false;
            this.editButtons = false;
            this.viewButtons = true;
            this.timeStamps = true;
            this.isEditing = false;
        },

        hasPermission(permission) {
            return this.currentUserMenu.permissions.some(function(el) {
                return el.name === permission;
            }); 
        },

        addNewMatchAchievementItem(row) {
            for(var i=0; i<row; i++){
                this.match.achievements.push(
                    { description: null, event_date: null }
                )
            }
        },

        deleteMatchAchievementItem(index) {
            this.match.achievements.splice(index, 1);
        },

    },


    components: {
        KTCard,
        //Multiselect
    },

    created() {
        this.isEditing = !this.isEditing;
        this.formType = this.$route.params.formType;
        this.$store.dispatch('getUserMenu');
        this.$store.dispatch('createMatchForm');
        this.match.is_active = 1;
        if (this.formType != "add") {
            var id = this.$route.params.id;
            this.$store.dispatch(GET_MATCH_DATA, { id })
            .then(( response ) => {
                this.match = response.data;
                this.match.user_created_name = response.data.user_created_name[0].name;
                this.match.user_updated_name = response.data.user_updated_name[0].name;
            })
        }
    },

    mounted() {
        
        if(this.formType === "add"){
            this.changeFormToAdding();
        }
        if(this.formType === "edit"){
            this.changeFormToEditing();
        }
        if(this.formType === "view"){
            this.changeFormToViewing();
        }
    },

    computed: {
        ...mapGetters(["currentUserMenu"]),

        ...mapState({
            loading: state => state.matches.loading,
            row: state => state.matches.row,
            errors: state => state.matches.errors,
            isDisabled: state => state.matches.isDisabled,
            //user: state => state.users.user_data
        })
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.view {
    border-color: transparent;
    background-color: initial;
    color: initial
}
</style>
